import { useRef } from "react";
import { normalizeOtp } from "../auth/otp";

export function OtpInput({ value, onChange, onComplete, disabled, arabic }: {
  value: string; onChange: (value: string) => void;
  onComplete: (value: string) => void; disabled: boolean; arabic: boolean;
}) {
  const inputs = useRef<(HTMLInputElement | null)[]>([]);
  // Spaces retain empty middle cells when a digit is removed.
  const cells = value.padEnd(4, " ").split("");
  function update(index: number, raw: string) {
    const digits = normalizeOtp(raw);
    const next = [...cells];
    const start = digits.length === 4 ? 0 : index;
    if (!digits) next[index] = " ";
    else for (let i = 0; i < digits.length && start + i < 4; i++) next[start + i] = digits[i];
    const code = next.join("");
    onChange(code);
    if (digits) inputs.current[Math.min(start + digits.length, 3)]?.focus();
    if (/^\d{4}$/.test(code)) onComplete(code);
  }
  return <div className="otp-fields" role="group" aria-labelledby="otp-label" dir="ltr">
    {cells.map((digit, index) => <input
      key={index}
      ref={(element) => { inputs.current[index] = element; }}
      aria-label={arabic ? `الرقم ${index + 1} من رمز التحقق` : `Verification digit ${index + 1}`}
      aria-describedby="otp-hint"
      type="text" inputMode="numeric" autoComplete={index === 0 ? "one-time-code" : "off"}
      maxLength={4} pattern="[0-9]" required disabled={disabled}
      value={digit.trim()} autoFocus={index === 0}
      onFocus={(event) => event.currentTarget.select()}
      onChange={(event) => update(index, event.target.value)}
      onPaste={(event) => { event.preventDefault(); update(index, event.clipboardData.getData("text")); }}
      onKeyDown={(event) => {
        if (event.key === "Backspace" && !digit.trim() && index > 0) {
          event.preventDefault(); update(index - 1, ""); inputs.current[index - 1]?.focus();
        } else if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
          event.preventDefault(); inputs.current[index + (event.key === "ArrowLeft" ? -1 : 1)]?.focus();
        }
      }}
    />)}
  </div>;
}
